import { Button, TitleBar } from "modules/common";
import { IProfileAccountDeactivationProps } from "modules/common/components/ProfileAccountDeactivation/types/IProfileAccountDeactivationProps";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

export function ProfileAccountDeactivation({
    profile,
    toggleDeactivateModal,
}: IProfileAccountDeactivationProps) {
    const { fontSize, lowVision } = useContext(AccessibilityContext);
    return (
        <>
            {profile?.isActive && (
                <>
                    <section>
                        <TitleBar>
                            <TitleBar.Left>
                                <span className="title-bar-text profile-title" style={{ fontSize: `${fontSize}%` }}>
                                    Deaktivacija računa
                                </span>
                            </TitleBar.Left>
                            <TitleBar.Right>
                                <span className="title-bar-description" style={{ fontSize: `${fontSize}%` }}>
                                    Deaktivacijom računa gubite pravo pristupa e-Savjetnik sustavu.
                                </span>
                            </TitleBar.Right>
                        </TitleBar>
                        <Button
                            className="deactivation-button"
                            type="button"
                            variant="warning"
                            lowVision={lowVision}
                            size="small"
                            onClick={toggleDeactivateModal}
                        >
                            <span className="deactivation-text">Deaktivacija računa</span>
                        </Button>
                    </section>
                </>
            )}
        </>
    );
}
